const rutasInventario = [
  //Inventario
  {
    name: "mascarasInventario",
    type: "gltfModel",
    path: "modelos/mascaras/NOMENCLATURA.gltf",
  },
  {
    name: "mascarasZonas",
    type: "gltfModel",
    path: "modelos/mascaras/MASCARAS COMUNALES.glb",
  },
  {
    name: "inventario",
    type: "json",
    path: "inventario/inventarioMuestra.json",
  },
]

export default rutasInventario;